import type {HostMap} from '../../../types'

export const PRODUCTION = {
  account: 'delivery-frontend-account-yandexcom.delivery.yandex.net',
  auth: 'delivery-frontend-auth-yandexcom.delivery.yandex.net',
  route: 'ddelivery-frontend-route-yandexcom.delivery.yandex.net',
  tariffs: 'delivery-frontend-tariffs-lb-yandexcom.delivery.yandex.net',
  yaAuthProxy: {
    default: 'ya-authproxy.taxi.yandex.com',
    authorized: 'ya-authproxy.taxi.yandex.com',
  },
  s3: {
    default: 'static.yandexcom.net',
  },
  avatars: 'avatars.mds.yandexcom.net',
  rum: 'clck.yandexcom.net',
  cspReport: 'csp.yandexcom.net',
  passport: {
    default: 'passport.yandex.com',
    id: 'id.yandex.com',
    api: 'api.passport.yandex.com',
  },
  metrica: {default: 'mcint.yandex.com'},
  forms: {default: 'forms-int.yandex.com'},
  maps: {
    default: 'js.api.maps.yandexcom.net',
  },
} as const satisfies HostMap
